import { Injectable } from '@angular/core';

@Injectable()
export class PeriodsService {
  getYears() {
    return [
      '2010', '2011', '2012',
      '2013', '2014', '2015',
      '2016', '2017', '2018',
    ];
  }

  getMonths() {
    return [
      'Jan', 'Feb', 'Mar',
      'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep',
      'Oct', 'Nov', 'Dec',
    ];
  }

  getWeeks() {
    return [
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat',
      'Sun',
    ];
  }
  getDays() {
    return [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7'
    ];
  }
  getHours() {
    return [
      '9-10',
      '10-11',
      '11-12',
      '12-1',
      '1-2',
      '2-3',
      '4-5'
    ];
  }
}
